import axios from "axios";
import React from "react";
import { useRouteMatch } from "react-router-dom";
import AnnouncementForm from "../components/Announcement/AnnouncementForm";
import GoBackButton from "../components/Misc/GoBackButton";
import Loading from "../components/Misc/Loading";
import { api } from "../config";
import { Announcement } from "../types/apiTypes";

const AnnouncementFormPage: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [announcement, setAnnouncement] = React.useState<Announcement>();
  const match = useRouteMatch("/admin/announcement-form/:id");
  const isEdit = match !== null;
  let id = "";

  if (isEdit) {
    //@ts-ignore
    id = match?.params.id;
  }
  const fetchAnnouncement = React.useCallback(async () => {
    const { data } = await axios.get(`${api}/announcements/${id}`, {
      withCredentials: true,
    });
    setAnnouncement(data);
    setLoading(false);
  }, [id]);

  React.useEffect(() => {
    if (id) {
      fetchAnnouncement();
    } else {
      setLoading(false);
    }
  }, [fetchAnnouncement, id]);

  if (loading) return <Loading />;

  if (id) {
    return (
      <div>
        <GoBackButton />
        <AnnouncementForm announcement={announcement} />
      </div>
    );
  }
  return (
    <div>
      <GoBackButton />
      <AnnouncementForm />
    </div>
  );
};

export default AnnouncementFormPage;
